export default {
  DEBUG: false,
  QRS: {
    GatewayURL:
      'http://stgqrssql01.corp.archcapservices.com:8080/ArchReGwt/hello?user=aw&startPageName=viewLocationRates&introducerIdentifier=',
    PowerBIReportsUrl:
      'https://app.powerbi.com/groups/91c13d2f-ea27-4efc-a9c5-119bdd713568/list?ctid=441d4a8f-7999-4d6a-9670-672cf8d03e35&experience=power-bi',
  },
  //This flag is used to determine if policy renew operation to be done from FE side or server side. False value does the renew operation in FE side. True does in Server side. TODO:// Remove/change to true once BE is ready
  POLICY: {
    renewalFromServer: true,
    isPolicyReferenceNumberFeatureOn: false,
    certAndNotificationFromTransaction: false,
  },
  PROGRAM: {
    isPricingFeatureOn: true,
    isARFGenerated: true,
  },
  WORKFLOW: {
    isIRFeatureOn: false,
  },
  AUTHENTICATION: {
    MODE: 'AUTH0',
    DOMAIN: 'archre.us.auth0.com',
    CLIENT_ID: 'ZxkDw2xllTNWeiIjFmf1qE9SldZi8b3L',
    CALLBACK_URL: `https://${window.location.host}/callback`,
    AUDIENCE: 'https://archway-copy.archre.com/api',
    LOGOUT_URL: `https://${window.location.host}/`,
  },
  LOCATION: {
    locationUrl: 'https://vinta-stg.archre.com/locations',
  },
  VINTA: {
    BASE_URL: 'https://vinta-copy.archre.com',
  },
  // Set to the copy environment's filer mailbox when one is provisioned; empty disables the Cc filer routing for this env.
  FILER_MAILBOX_ADDRESS: '',
};
